export const wrapperWithDividerStyles = {
  width: '100%',

  '& .title-container, & .title': {
    width: '100%',
  },
};

export const dividerStyles = {
  margin: '20px 0 0',
  borderBottomWidth: '1px',
  borderColor: ({ palette }) => palette.border.default,
};

export const listControlsStyles = {
  gap: '8px',
};

export const employerAddressTitleStyles = {
  margin: '24px 0 12px',
  color: ({ palette }) => palette.text.secondary,
  fontWeight: 700,
};

export const typographyStyles = {
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '16px',
  color: ({ palette }) => palette.text.dark,
};

export const emptyMessageCellStyles = {
  padding: 0,
  '& .table-cell__content_box': {
    padding: '8px !important',
    height: 'unset !important',
  },
};

export const tableWrapperStyle = {
  padding: 0,
};

export const employmentVerificationContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  paddingTop: '24px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const employmentVerificationFormControlsStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};

export const addVerificationButtonsRowStyles = {
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
};

export const groupCustomStyles = {
  paddingTop: '12px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};
